<template>
  <kinesis-container id="popup" class="bg-purple align-items-center flex-column">
    <b-container>
      <b-row class="flex-row-reverse">
        <b-button
          variant="transparent"
          class="text-white position-relative"
          style="z-index: 2;"
          @click.prevent="displayNonePopup()"
        >
          <i class="fas fa-times"></i>
        </b-button>
      </b-row>
    </b-container>

    <b-container style="margin-top: -80px !important;">
      <b-row>
        <b-col md="5" class="hide-at-md">
          <kinesis-element :strength="8" class="text-center">
            <img class="logo-1" :src="require(`@/assets/images/only-coin.png`)" width="300" />
          </kinesis-element>

          <kinesis-element :strength="20" class="text-center">
            <img class="logo-2" :src="require(`@/assets/images/only-coin.png`)" width="150" />
          </kinesis-element>

          <kinesis-element :strength="10" class="text-center">
            <img class="logo-3" :src="require(`@/assets/images/only-coin.png`)" width="50" />
          </kinesis-element>
        </b-col>

        <b-col
          md="7"
          class="rounded p-5 d-flex justify-content-center align-items-center flex-column bg-white"
          style="box-shadow: 10px 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;"
        >
          <h1 class="text-purple text-center mb-3" v-html="content[0].title" />
          <p class="text-purple text-center mb-5" v-html="content[0].text" />

          <router-link :to="content[0].link">
            <b-button
              variant="light"
              @click="displayNonePopup()"
              class="text-purple font-weight-bold btn-lg shadow px-5 py-3 rounded"
              v-html="content[0].btnLink"
            />
          </router-link>
        </b-col>
      </b-row>
    </b-container>
  </kinesis-container>
</template>

<script>
export default {
  data: () => ({
    controlPopup: "",
    randNumber: "",
    content: [
      {
        title: "Ei, espera ai!",
        text:
          'Cadastre seu veículo e nossos consultores entrarão em contato. <br><a href="/vender-meu-carro">Ir para o cadastro →</a>',
        btnLink: "Fechar",
        link: "/"
      },
      {
        title: "Seja um Franqueado!",
        text:
          "Agora você pode ter o seu Show Room de veículos virtual e movimentar milhões em veículos sem nenhum carro no estoque físico",
        btnLink: "Cadastrar-se",
        link: "/seja-um-franqueado"
      },
      {
        title: "lala",
        text: "Cadastre seu veículo e nossos consultores entrarão em contato",
        btnLink: "Cadastrar veículo",
        link: "/vender-meu-carro"
      }
    ]
  }),
  methods: {
    controlPopupStorage: () => {
      let popupWindow = localStorage.getItem("POPUP_WINDOW")
        ? localStorage.getItem("POPUP_WINDOW")
        : "";

      if (popupWindow != "" && parseInt(popupWindow) <= 2) {
        popupWindow = parseInt(popupWindow) + 1;

        localStorage.removeItem("POPUP_WINDOW");
        localStorage.setItem("POPUP_WINDOW", popupWindow);
      } else {
        localStorage.removeItem("POPUP_WINDOW");
      }
    },
    rand(min, max) {
      if (min == 0) {
        return Math.floor(Math.random() * max + 0);
      } else {
        return Math.floor(Math.random() * (max - min + 1)) + min;
      }
    },
    displayNonePopup() {
      document.getElementById("popup").style.display = "none";
    },
    addEvent(obj, evt, fn) {
      if (this.controlPopup == "") {
        if (obj.addEventListener) {
          obj.addEventListener(evt, fn, false);
        } else if (obj.attachEvent) {
          obj.attachEvent("on" + evt, fn);
        }
      }
    }
  },
  mounted() {
    this.randNumber = this.rand(0, this.content.length);
    this.controlPopupStorage();
    if (!localStorage.getItem("POPUP_WINDOW")) {
      let addEventCapsule = this.addEvent;

      this.addEvent(window, "load", () => {
        localStorage.setItem("POPUP_WINDOW", 1);
        addEventCapsule(document, "mouseout", e => {
          e = e ? e : window.event;
          let from = e.relatedTarget || e.toElement;
          if (!from || from.nodeName == "HTML")
            if (this.controlPopup == "") {
              document.getElementById("popup").style.display = "flex";
              this.controlPopup = "1";
            }
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.hide-at-md {
  @media screen and (max-width: 768px) {
    display: none;
  }
}

#popup {
  display: none;
  width: 85vw;
  height: 70vh;
  position: fixed;
  top: 15vh;
  left: 7.5vw;
  z-index: 999;
  box-shadow: 0px 0px 121px 200px rgba(74, 25, 101, 1);
}

.logo-1 {
  position: relative;
  left: 70px;
  top: 10px;
  transform: rotate(-20deg);
}

.logo-2 {
  position: relative;
  left: -50px;
  top: -20px;
  transform: rotate(20deg);
  filter: blur(0.09rem);
}

.logo-3 {
  position: relative;
  left: 0px;
  top: 0px;
  transform: rotate(-9deg);
  filter: blur(0.1rem);
}
</style>
